import { Component, inject, viewChild } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateDirective } from '@ngx-translate/core';
import {
  DatePipe,
  DropdownComponent,
  DropdownItemComponent,
  FormComponent,
  FormRowComponent,
  InputDirective,
  InputErrorsComponent,
  InputGroupComponent,
  InputGroupFieldComponent,
  InputGroupLabelComponent,
  InputStatusIndicatorDirective,
  NotificationComponent,
  PostalCodeValidatorDirective,
  ProvincesStatesCodesService,
  TranslatePipe
} from '@tdwb/core';
import { AgreementsDateBaseDirective } from '../agreements.base';
export interface OpraAgreementFormModel {
  clientFirstName: string,
  clientLastName: string,
  addressLine1: string,
  addressLine2: string,
  city: string,
  provinceState: string,
  postalCode: string
}
@Component({
  selector: 'td-wb-opra-agreement',
  templateUrl: './opra-agreement.component.html',
  styleUrls: ['../agreements.component.scss'],
  imports: [
    NgTemplateOutlet,
    FormsModule,
    TranslateDirective,
    NotificationComponent,
    DatePipe,
    FormComponent,
    FormRowComponent,
    InputGroupComponent,
    InputGroupLabelComponent,
    InputGroupFieldComponent,
    InputDirective,
    InputErrorsComponent,
    InputStatusIndicatorDirective,
    DropdownComponent,
    DropdownItemComponent,
    TranslatePipe,
    PostalCodeValidatorDirective
  ]
})
export class OpraAgreementComponent extends AgreementsDateBaseDirective {
  protected readonly form = viewChild(FormComponent);
  protected readonly provinceStatesCodesService = inject(ProvincesStatesCodesService);
  formModel: OpraAgreementFormModel = {
    clientFirstName: '',
    clientLastName: '',
    addressLine1: '',
    addressLine2: '',
    city: '',
    provinceState: '',
    postalCode: ''
  };

  trySubmitAndReturnModel(): OpraAgreementFormModel {
    const form = this.form();
    return form !== undefined && super.trySubmit(form) ? this.formModel : undefined;
  }
}
